// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { taiko as _taiko } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the taiko chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 167000
 * Chain Name: Taiko Mainnet
 * Default Block Explorer: https://taikoscan.io
 * Default RPC URL: https://rpc.mainnet.taiko.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { taiko } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: taiko,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const taiko = createCommon({
	..._taiko,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
